<div class="form-section">
  <label [attr.for]="id" [class.required-field]="required">{{ label }}</label>

  <!-- 編號顯示區域 -->
  <div class="auto-numbering-display">
    <input
      [id]="id"
      [name]="name"
      type="text"
      [value]="displayValue"
      readonly
      class="form-input numbering-result"
      [placeholder]="generatingNumber ? ('正在生成編號...' | translate) : (placeholder || ('將自動生成編號' | translate))"
    />

    <!-- 重新生成按鈕 -->
    <button
      type="button"
      class="btn btn-sm btn-outline-primary regenerate-btn"
      (click)="regenerateNumber()"
      [disabled]="generatingNumber || !canGenerate"
      [title]="'重新生成編號' | translate">
      <i class="fas fa-sync-alt" [class.fa-spin]="generatingNumber"></i>
    </button>
  </div>

  <!-- 下拉選單輸入區域 -->
  <div class="dropdown-inputs" *ngIf="dropdownElements.length > 0">
    <div class="input-group" *ngFor="let element of dropdownElements; let i = index">
      <label class="input-label">{{ getDropdownLabel(element, i) }}</label>
      <select
        class="form-control form-select"
        [(ngModel)]="dropdownValues['dropdown_' + element.order]"
        (ngModelChange)="onDropdownChange()"
        [disabled]="generatingNumber">
        <option value="" disabled>{{ getDropdownPlaceholder(element) }}</option>
        <option *ngFor="let option of getDropdownOptions(element)" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>

  <!-- 錯誤訊息 -->
  <div *ngIf="errorMessage" class="error-message">
    <i class="fas fa-exclamation-triangle"></i>
    {{ errorMessage }}
  </div>

  <!-- 載入狀態 -->
  <div *ngIf="generatingNumber" class="loading-message">
    <i class="fas fa-spinner fa-spin"></i>
    {{ '正在生成編號...' | translate }}
  </div>
</div>
